import classNames from "classnames";

const LoadingIndicator = (props: {
  colorSet: 'white' | 'black';
}) => {
  const colorClassSet = {
    'white': {
      'background': 'bg-transparent',
      'indicator': 'bg-black',
    },
    'black': {
      'background': 'bg-black/10',
      'indicator': 'bg-white',
    },
  }

  if (props.colorSet !== 'white' && props.colorSet !== 'black') {
    props.colorSet = 'white';
  }

  return (
    <div className={classNames([
      "absolute inset-0 flex flex-col items-center justify-center rounded-[4px] z-50",
      colorClassSet[props.colorSet]['background'],
    ])}>
      {/* <div className="relative w-16 h-16 mb-4">
            <div className="absolute inset-0 border-2 border-transparent border-t-white rounded-full animate-spin"></div>
            <div
            className="absolute inset-2 rounded-full animate-pulse"
            style={{
                background: 'radial-gradient(circle, rgba(255,255,255,0) 12px, rgba(255,255,255,1) 24px)',
            }}
            ></div>
        </div>
      */}
      <div className="text-white font-medium tracking-wider flex items-center space-x-1">
        {['0ms', '200ms', '400ms', '600ms', '800ms'].map((delay, i) => (
          <span
            key={i}
            className={classNames([
              "inline-block w-1 h-1 animate-ping",
              colorClassSet[props.colorSet]['indicator'],
            ])}
            style={{ animationDelay: delay }}
          >
          </span>
        ))}
      </div>
    </div>
  );
}

export default LoadingIndicator;